import React from "react";
import {observer} from "mobx-react";
import {Badge, Button, Card, Col, Container, Row} from "react-bootstrap";

function AdminDashboard() {

    return (
        <Container className="dashboard-shell">
            <div className="dashboard-hero" data-accent="admin">
                <div>
                    <div className="dashboard-eyebrow">Admin Console</div>
                    <h1>System overview</h1>
                    <p>Manage tax authorities, review activity, and keep operations running smoothly.</p>
                </div>
                <div className="dashboard-hero-actions">
                    <Button variant="primary" href="/admin/taxAuth">Manage Tax Authorities</Button>
                    <Button variant="outline-secondary" href="/admin/orders">View Orders</Button>
                </div>
            </div>

            <Row className="mt-4 g-3">
                {[
                    {label: "Active Tax Authorities", value: "N/A"},
                    {label: "Orders Today", value: "N/A"},
                    {label: "Pending Reviews", value: "N/A"}
                ].map((stat) => (
                    <Col md={4} key={stat.label}>
                        <Card className="stat-card">
                            <Card.Body>
                                <div className="stat-label">{stat.label}</div>
                                <div className="stat-value">{stat.value}</div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Row className="mt-4 g-4">
                <Col lg={8}>
                    <Card className="dashboard-panel">
                        <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                            <strong>Quick Actions</strong>
                            <Badge bg="light" text="dark">Admin tools</Badge>
                        </Card.Header>
                        <Card.Body>
                            <Row className="g-3">
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-building-gear"></i></div>
                                        <div>
                                            <h6>Tax Authorities</h6>
                                            <p className="text-muted mb-2">Onboard new municipalities and manage access.</p>
                                            <Button variant="outline-primary" href="/admin/taxAuth">Open</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-receipt"></i></div>
                                        <div>
                                            <h6>Orders</h6>
                                            <p className="text-muted mb-2">Review order activity and troubleshoot issues.</p>
                                            <Button variant="outline-primary" href="/admin/orders">Open</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-bar-chart"></i></div>
                                        <div>
                                            <h6>Reports</h6>
                                            <p className="text-muted mb-2">Run billing and compliance reports.</p>
                                            <Button variant="outline-primary" href="/admin/reports">Open</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="dashboard-action">
                                        <div className="action-icon"><i className="bi bi-box-seam"></i></div>
                                        <div>
                                            <h6>Products</h6>
                                            <p className="text-muted mb-2">Manage tax certificate products and pricing.</p>
                                            <Button variant="outline-primary" href="/admin/products">Open</Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={4}>
                    <Card className="dashboard-panel mb-4">
                        <Card.Body>
                            <h5 className="mb-2">System Notes</h5>
                            <p className="text-muted mb-3">No incidents reported. Keep an eye on outage reports for municipal systems.</p>
                            <Button variant="outline-secondary" href="/admin/reports">View Reports</Button>
                        </Card.Body>
                    </Card>
                    <Card className="dashboard-panel">
                        <Card.Body>
                            <h6 className="mb-2">Invite a Tax Authority</h6>
                            <p className="text-muted mb-3">Send a new onboarding invite when a municipality is ready.</p>
                            <Button variant="primary" href="/admin/inviteTaxAuth">Send Invite</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default observer(AdminDashboard);
